import clsx from "clsx"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamation} from "@fortawesome/free-solid-svg-icons";
import Image from "react-bootstrap/Image";

function EmptyItemView({title = "No Item Found", extraCss}){
    return <div className={clsx("empty-item-view")} style={extraCss}>
        {/*<FontAwesomeIcon icon={faExclamation} size="xl"></FontAwesomeIcon>*/}
        <Image src="/img/icon/exclamation-mark.png" style={{ width: "18px", objectFit: "contain" }} />
        <span >{title}</span>
    </div>
}

export default EmptyItemView
